import Stack from '@mui/material/Stack';
import { colors, IconButton, Tooltip, Typography } from '@sweep-io/sweep-design';
import { ChevronRight, Close } from '@sweep-io/sweep-design/dist/icons';
import { DocumentationTab } from '../building-blocks/DocumentationTabsLayout';

interface TabListItemProps {
  tab: DocumentationTab;
  handleTabChange: (tabId: string) => void;
  onRemoveTab: (tabId: string) => void;
  formatLabel?: (label: string) => string;
}

export const TabListItem = ({
  tab,
  handleTabChange,
  onRemoveTab,
  formatLabel = (label) => label,
}: TabListItemProps) => {
  return (
    <Stack
      key={tab.id}
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={{
        cursor: 'pointer',
        borderBottom: `1px solid ${colors.grey[120]}`,
        padding: '12px 16px 12px 24px',
        '& .remove-metadata-button': {
          display: 'none',
        },
        '&:hover': {
          backgroundColor: colors.grey[100],

          '& .remove-metadata-button': {
            display: tab.isNotRemovable ? 'none' : 'flex',
          },
          '& .chevron-right-metadata-button': {
            display: tab.isNotRemovable ? 'flex' : 'none',
          },
        },
        '& .chevron-right-metadata-button': {
          display: 'flex',
        },
      }}
      onClick={() => handleTabChange(tab.id)}
    >
      <Typography variant="body-medium" color={colors.black}>
        {formatLabel(tab.label)}
      </Typography>
      <Stack className="remove-metadata-button">
        <Tooltip placement="top" title="Remove tab">
          <IconButton
            variant="flat"
            size="tiny"
            onClick={(e) => {
              e.stopPropagation();
              onRemoveTab(tab.id);
            }}
          >
            <Close />
          </IconButton>
        </Tooltip>
      </Stack>
      <Stack className="chevron-right-metadata-button">
        <IconButton variant="flat" size="tiny">
          <ChevronRight size="medium" />
        </IconButton>
      </Stack>
    </Stack>
  );
};
